class Caption {
  constructor(className, item = document) {
    this.init(className, item);
  }
  init = (className, item) => {
    let btnOpen = item?.querySelectorAll(`.${className}-open`);
    let btnClose = item?.querySelectorAll(`.${className}-close`);
    let imageCaption = item?.querySelectorAll(`.${className}`);
    btnOpen.forEach((btn, index) => {
      btn.addEventListener("click", () => {
        btn?.classList.remove("active");
        btnClose[index]?.classList.add("active");
        imageCaption[index].classList.add("active");
      });
    });
    btnClose.forEach((btn, index) => {
      btn.addEventListener("click", () => {
        btn?.classList.remove("active");
        btnOpen[index]?.classList.add("active");
        imageCaption[index].classList.remove("active");
      });
    });
  };
}

export default Caption;
